import React from 'react';
import { Users, TrendingUp, Clock, Award } from 'lucide-react';
import { statsData } from '../data/mock';

const iconMap = {
  Users,
  TrendingUp,
  Clock,
  Award
};

export default function Stats() {
  return (
    <section className="relative bg-white py-12 sm:py-16 border-b border-gray-100">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8">
          {statsData.map((stat) => {
            const Icon = iconMap[stat.icon];
            return (
              <div key={stat.id} className="text-center group">
                <div className="flex justify-center mb-3">
                  <div className="w-12 h-12 bg-[#ff444f]/10 rounded-full flex items-center justify-center group-hover:bg-[#ff444f]/20 transition-colors">
                    <Icon className="w-6 h-6 text-[#ff444f]" />
                  </div>
                </div>
                <div className="text-3xl sm:text-4xl font-bold text-gray-900 mb-2">
                  {stat.value}
                </div>
                <div className="text-sm sm:text-base text-gray-600 font-medium">
                  {stat.label}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
